module.exports = __webpack_public_path__ + "img/check-red.5b15d005.svg";